/**
 * Auto-archive paid demands when Automations → autoArchivePaidDemands is on.
 */

import { isPaidStatus } from './paidBeforeAssignment.js';
import { archiveMatters } from './bulkDemandActions.js';

export function isAutoArchivePaidEnabled(automations = {}) {
  return Boolean(automations?.autoArchivePaidDemands);
}

/**
 * Archive a matter when it is paid and the automation is enabled.
 * @returns {{ archived: boolean, matter: object, reason: string|null }}
 */
export function maybeAutoArchivePaidMatter(
  matter,
  { automations = {}, billing = {}, currentArchivedCount } = {}
) {
  if (!matter || !isAutoArchivePaidEnabled(automations)) {
    return { archived: false, matter, reason: null };
  }
  if (!isPaidStatus(matter.Status)) {
    return { archived: false, matter, reason: null };
  }
  if (matter.Archived) {
    return { archived: false, matter, reason: null };
  }

  const result = archiveMatters([matter], { billing, currentArchivedCount });
  if (!result.updated.length) {
    return {
      archived: false,
      matter,
      reason: result.reason || 'SKIPPED',
    };
  }
  return {
    archived: true,
    matter: result.updated[0],
    reason: null,
  };
}
